// extracted by mini-css-extract-plugin
module.exports = {"modal":"FeedbackModal_modal__kfHMy"};